// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file Procedure.proto (package Procedure, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Procedure.proto.
 */
export const file_Procedure: GenFile = /*@__PURE__*/
  fileDesc("Cg9Qcm9jZWR1cmUucHJvdG8SCVByb2NlZHVyZSKvBAoJUHJvY2VkdXJlEjMKDWFpcmNyYWZ0c3BlZWQYASABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWUSLQoIY29uZmlnSWQYAiABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIuCghmcmVldGV4dBgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRInCgJpZBgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi0KCW1hcHN0YXR1cxgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWUSKgoEbmFtZRgGIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIxCgtwcm9jZWR1cmVpZBgHIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIzCg1wcm9jZWR1cmV0eXBlGAggASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi4KCXByb2plY3RJZBgJIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjcKEnJlZmVyZW5jZUFpcnBvcnRQaxgKIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjkKE3JuYXZwZXJmb3JtYW5jZXR5cGUYCyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWVCPwotY29tLmdtdi5kZW1ldGVyLm5hdmFpZHMubW9kZWwucHJvdG8uZ2VuZXJhdGVkQg5Qcm9jZWR1cmVQcm90b2IGcHJvdG8z", [file_google_protobuf_wrappers]);

/**
 * @generated from message Procedure.Procedure
 */
export type Procedure = Message<"Procedure.Procedure"> & {
  /**
   * @generated from field: google.protobuf.DoubleValue aircraftspeed = 1;
   */
  aircraftspeed?: number;

  /**
   * @generated from field: google.protobuf.Int32Value configId = 2;
   */
  configId?: number;

  /**
   * @generated from field: google.protobuf.StringValue freetext = 3;
   */
  freetext?: string;

  /**
   * @generated from field: google.protobuf.Int32Value id = 4;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.BoolValue mapstatus = 5;
   */
  mapstatus?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue name = 6;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue procedureid = 7;
   */
  procedureid?: string;

  /**
   * @generated from field: google.protobuf.StringValue proceduretype = 8;
   */
  proceduretype?: string;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 9;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value referenceAirportPk = 10;
   */
  referenceAirportPk?: number;

  /**
   * @generated from field: google.protobuf.StringValue rnavperformancetype = 11;
   */
  rnavperformancetype?: string;
};

/**
 * Describes the message Procedure.Procedure.
 * Use `create(ProcedureSchema)` to create a new message.
 */
export const ProcedureSchema: GenMessage<Procedure> = /*@__PURE__*/
  messageDesc(file_Procedure, 0);

